import { FC } from "react";
import { Th, Tr, Thead, Box } from "@chakra-ui/react";
import { PlanLabel } from "./PlanLabel";

export const PlansThead: FC = () => {
  return (
    <Thead>
      <Tr h={{ base: "unset", md: "5rem" }}>
        <Th>
          <Box minW="100%" />
        </Th>
        <Th>
          <PlanLabel plan="plus" />
        </Th>
        <Th>
          <PlanLabel plan="premium" />
        </Th>
      </Tr>
    </Thead>
  );
};
